import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import { Accordion } from '../../../../components/base/Accordion/Accordion';
import WayBillDTO from '../../../../dto/WayBillDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import TimePicker from '../../../../components/fields/TimePicker/TimePicker';

export default function WayBillForm(props) {
  const { legalEntityType, control, formMeta } = props;
  const dto = new WayBillDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_external_id}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.carrier_external_id}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          onChangeToIso
          withLabel
          dtoObject={attributes.waybill_dispatched_at}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          onChangeToIso
          withLabel
          dtoObject={attributes.waybill_returned_at}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          onChangeToIso
          withLabel
          dtoObject={attributes.waybill_valid_from_date}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          onChangeToIso
          withLabel
          dtoObject={attributes.waybill_valid_until_date}
          variant="material"
        />
      </Row>
      <Accordion
        title="Медицинский осмотр"
        content={(
          <>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.driver_external_id}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_pre_trip_medical_exam_result}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_medical_examiner}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_pre_trip_medical_exam_location}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={DateTimePicker}
                onChangeToIso
                withLabel
                dtoObject={attributes.waybill_pre_trip_medical_exam_at}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_post_trip_medical_exam_result}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_post_medical_examiner}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={DateTimePicker}
                onChangeToIso
                withLabel
                dtoObject={attributes.waybill_post_trip_medical_exam_at}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TimePicker}
                dtoObject={attributes.waybill_post_trip_medical_exam_at_time}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_post_trip_medical_exam_location}
                variant="material"
              />
            </Row>
          </>
        )}
      />
      <Accordion
        title="Состояние автомобиля"
        content={(
          <>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_pre_trip_inspection_result}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_technical_inspection_location}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={DateTimePicker}
                onChangeToIso
                withLabel
                dtoObject={attributes.waybill_pre_trip_inspection_at}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={DateTimePicker}
                onChangeToIso
                withLabel
                dtoObject={attributes.waybill_pre_trip_inspection_at}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_technical_inspection_controllers_info}
                variant="material"
              />
            </Row>
            <Row className="row-cols-2">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_odometer_dispatch}
                variant="material"
              />
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_odometer_return}
                variant="material"
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.waybill_odometer_handover}
                variant="material"
              />
            </Row>
          </>
        )}
      />
      <Accordion
        title="Отметки"
        content={(
          <Row className="row-cols-2">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.waybill_transportation_type}
              variant="material"
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.waybill_route_type}
              variant="material"
            />
          </Row>
        )}
      />
    </>
  );
}
